import DOMPurify from "dompurify";

interface ISafeHtmlProps {
  html: string | null;
}

const SafeHtml: React.FC<ISafeHtmlProps> = ({ html }) => {
  const safe = html ?? "";
  const clean = DOMPurify.sanitize(safe);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: clean }}
      style={{ whiteSpace: "normal" }}
    />
  );
};

export default SafeHtml;
